<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface DataListItemTitleProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '../../../lib/utils'
  const props = defineProps<DataListItemTitleProps>()
</script>

<template>
  <div :class="cn('truncate text-sm font-medium', props.class)">
    <slot />
  </div>
</template>
